module.exports = __webpack_public_path__ + "static/media/curriculumCompletion.c62e67c6.svg";